import makeErrorCause from 'make-error-cause';

export const UnauthorizedError = makeErrorCause('UnauthorizedError');
export const WrappedError = makeErrorCause('WrappedError');
